import { z } from "zod";

export const dateFormatter = new Intl.DateTimeFormat("en-US", {
	weekday: "long",
	year: "numeric",
	month: "long",
	day: "numeric",
});

export const previewDateFormatter = new Intl.DateTimeFormat("en-US", {
	weekday: "long",
	month: "long",
	day: "numeric",
});

export const previewTimeFormatter = new Intl.DateTimeFormat("en-US", {
	hour: "numeric",
	minute: "2-digit",
	hour12: true,
});

export const createEventFormSchema = z.object({
	title: z
		.string()
		.min(1, "Title is required")
		.max(100, "Title must be less than 100 characters")
		.transform((str) => str.trim()),
	description: z
		.string()
		.max(2000, "Description must be less than 2000 characters")
		.optional()
		.transform((str) => (str ? str.trim() : null)),
	coverImage: z.instanceof(File).optional().nullable(),
	coverImageUrl: z.string().optional(),
	startDate: z.string().min(1, "Required"),
	startTime: z.string().min(1, "Required"),
	locationAddress: z.string().min(1, "Required"),
	locationLink: z.string().optional(),
	locationCoordinates: z.string().optional(),
	locationUrl: z.string().optional(),
	guestListVisibility: z.boolean().default(true),
	guestLimit: z.preprocess(
		(val) =>
			val === "" || val === null || val === undefined ? undefined : Number(val),
		z.number().optional(),
	),
	allowPlusOne: z.boolean(),
	hasAIGeneratedCoverImage: z.boolean().default(false),
	collectDietaryRestrictions: z.boolean().default(false),
});

export const updateEventFormSchema = createEventFormSchema.merge(
	z.object({
		coverImageUrl: z.string().optional(),
	}),
);

export type CreateEventFormData = z.infer<typeof createEventFormSchema>;
export type UpdateEventFormData = z.infer<typeof updateEventFormSchema>;

export type EventFormData = CreateEventFormData | UpdateEventFormData;

/**
 * Check if a string is a valid Google Maps URL
 */
export function isGoogleMapsUrl(url: string): boolean {
	try {
		const urlObj = new URL(url);
		return (
			(urlObj.hostname.includes("google.com") &&
				urlObj.pathname.includes("/maps")) ||
			urlObj.hostname.includes("goo.gl")
		);
	} catch (e) {
		return false;
	}
}
